import { Media, UI } from '@cowprotocol/ui'

import { Link } from 'react-router'
import styled from 'styled-components/macro'

export const Tabs = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 2px;
  margin: 0;

  ${Media.upToMedium()} {
    display: none;
  }
`

export const SelectContainer = styled.div`
  display: none;
  width: 100%;
  margin: 0;
  position: relative;

  ${Media.upToMedium()} {
    display: block;
  }

  &::after {
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    width: 8px;
    height: 8px;
    border-right: 2px solid var(${UI.COLOR_TEXT_OPACITY_50});
    border-bottom: 2px solid var(${UI.COLOR_TEXT_OPACITY_50});
    transform: translateY(-70%) rotate(45deg);
    pointer-events: none;
    transition: border-color var(${UI.ANIMATION_DURATION}) ease-in-out;
  }

  &:hover::after {
    border-color: var(${UI.COLOR_TEXT});
  }
`

export const Select = styled.select`
  width: 100%;
  padding: 10px 40px 10px 10px;
  border-radius: 14px;
  border: 1px solid var(${UI.COLOR_TEXT_OPACITY_10});
  background: var(${UI.COLOR_PAPER});
  color: inherit;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  text-align: left;
  transition: border-color var(${UI.ANIMATION_DURATION}) ease-in-out;

  &:hover,
  &:focus {
    border-color: var(${UI.COLOR_TEXT_OPACITY_50});
  }

  option {
    padding: 10px;
    background: var(${UI.COLOR_PAPER});
    color: inherit;
  }
`

export const TabButton = styled(Link)<{
  $isActive?: boolean
  $isUnfillable?: boolean
  $isSigning?: boolean
  $isDisabled?: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: ${({ $isActive, $isUnfillable, $isSigning, $isDisabled }) =>
    $isDisabled
      ? 'transparent'
      : $isActive
        ? $isUnfillable
          ? `var(${UI.COLOR_DANGER_BG})`
          : $isSigning
            ? `var(${UI.COLOR_ALERT_BG})`
            : `var(${UI.COLOR_TEXT_OPACITY_10})`
        : 'transparent'};
  color: ${({ $isActive, $isUnfillable, $isSigning, $isDisabled }) =>
    $isDisabled
      ? `var(${UI.COLOR_TEXT_OPACITY_50})`
      : $isUnfillable
        ? `var(${UI.COLOR_DANGER})`
        : $isSigning
          ? `var(${UI.COLOR_ALERT_TEXT})`
          : $isActive
            ? `var(${UI.COLOR_TEXT_PAPER})`
            : 'inherit'};
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '400')};
  border-radius: 14px;
  text-decoration: none;
  font-size: 13px;
  padding: 8px;
  border: 0;
  outline: none;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
  transition:
    background var(${UI.ANIMATION_DURATION}) ease-in-out,
    color var(${UI.ANIMATION_DURATION}) ease-in-out;
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
  white-space: nowrap;

  ${Media.upToMedium()} {
    text-align: center;
  }

  &:hover {
    background: ${({ $isDisabled, $isUnfillable }) =>
      $isDisabled ? 'transparent' : $isUnfillable ? `var(${UI.COLOR_DANGER_BG})` : `var(${UI.COLOR_TEXT_OPACITY_10})`};
    color: ${({ $isDisabled, $isUnfillable }) =>
      $isDisabled ? `var(${UI.COLOR_TEXT_OPACITY_50})` : $isUnfillable ? `var(${UI.COLOR_DANGER})` : 'inherit'};
  }

  > svg {
    width: 14px;
    height: 14px;
    fill: currentColor;
  }

  > svg > path {
    fill: currentColor;
  }
`
